import React from 'react';

//cmponents
import { Input } from '@lyearn/ui';
import { KeyCodes } from '@/consts/keyCodes';

//types
import { FilterInputProps } from '../types';

const FilterInputNumber = (props: FilterInputProps) => {
  const { value, onChange } = props;

  const onKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement | HTMLButtonElement>,
  ) => {
    if (event.key === KeyCodes.Enter) {
      //@ts-ignore
      const value = event.target.value;
      onChange(value);
    }
  };

  const onBlur = (event: React.ChangeEvent<{ value: string }>) => {
    const value = event.target.value;
    onChange(value);
  };

  return (
    <Input
      defaultValue={value}
      placeholder="Value"
      type="number"
      onBlur={onBlur}
      onKeyDown={onKeyDown}
    />
  );
};

export default FilterInputNumber;
